export default __webpack_public_path__ + "static/media/mall-ico.f82bb1b9.svg";